module.exports = __webpack_public_path__ + "static/media/quran-background.9feeaa9d.png";